import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  NavigationEnd,
} from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from '../data.service';
import { filter, tap } from 'rxjs/operators';
import { UtilitiesService } from '../utilities.service';
@Injectable({
  providedIn: 'root',
})
export class ResolveGuard implements Resolve<any> {
  constructor(
    private dataService: DataService,
    private router: Router,
    private utilitiesService: UtilitiesService
  ) {}

  // tslint:disable-next-line:typedef
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let moduleName: string =
      route.routeConfig.path === '' || route.routeConfig.path === null
        ? 'CreditorLogin'
        : route.routeConfig.path;

    let path: string = 'general/' + moduleName;

    let sessionkeys: string[] = Object.keys(sessionStorage);

    sessionkeys = sessionkeys.filter(
      (x) =>
        x.toLocaleLowerCase() === ('Module_' + moduleName).toLocaleLowerCase()
    );

    if (sessionkeys.length === 0) {
      return this.dataService.getRequest(path);
    } else {
      return null;
    }
  }
}
